export enum AppStoreProvider {
 NONE = 'None',
 APPSTORE = 'App Store',
 GOOGLEPLAY = 'Google Play',
 MICROSOFTSTORE = 'Microsoft Store',
 AMAZONAPPSTORE = 'Amazon App Store',
}
